export default __webpack_public_path__ + "static/media/twitter-large.25a57e50.webp";